import useDefinedContext from "hooks/useDefinedContext";
import { SidebarContext } from "../SidebarProvider";

interface UseSidebarProps {}

function useSidebar(props?: UseSidebarProps) {
  return useDefinedContext(SidebarContext);
}

export default useSidebar;
